import { useNavigate } from "react-router-dom";

import { Icon } from "~/assets/icons/Icon";

import NotificationBlock from "../../notificationBlock/NotificationBlock";
import Button from "../../ui/button/Button";
import { tabs } from "./NewSite";
import styles from "./NewSiteVisibilityEngineHandoff.module.scss";

type NewSiteVisibilityEngineHandoffProps = {
  siteFqdn?: string | null;
  setActiveTab: (tab: string) => void;
};

const NewSiteVisibilityEngineHandoff = ({
  siteFqdn,
  setActiveTab,
}: NewSiteVisibilityEngineHandoffProps) => {
  const navigate = useNavigate();

  const continueToAutomations = () => {
    setActiveTab(tabs[4]);
    navigate(tabs[4]);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.panel}>
        <div className={styles.illustration}>
          <Icon iconName="PendingProcessPic" width="11.5rem" height="7.5rem" />
        </div>
        <div className={styles.copy}>
          <h2 className={styles.title}>AI Visibility Engine Setup</h2>
          <p className={styles.description}>
            {siteFqdn ? (
              <>
                Thanks for adding <strong>{siteFqdn}</strong>. Our Customer
                Success team is reviewing your site to determine the best way to
                integrate the AI Visibility Engine.
              </>
            ) : (
              <>
                Our Customer Success team is reviewing your site to determine
                the best way to integrate the AI Visibility Engine.
              </>
            )}
          </p>
          <p className={styles.description}>
            You will receive an email within one business day with next steps
            once the review is complete. No action is required from you right
            now.
          </p>
        </div>
        <div className={styles.notice}>
          <NotificationBlock
            type="info"
            message="Your site application for AI Visibility Engine Optimization has been submitted. We'll follow up by email with integration instructions tailored to your platform."
          />
        </div>
      </div>
      <div className={styles.footer}>
        <Button
          outlined
          onClick={() => {
            setActiveTab(tabs[3]);
            navigate(tabs[3]);
          }}
        >
          Back
        </Button>
        <Button onClick={continueToAutomations}>Continue</Button>
      </div>
    </div>
  );
};

export default NewSiteVisibilityEngineHandoff;
